import {BrowserModule, BrowserTransferStateModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {TransferHttpCacheModule} from '@nguniversal/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {CommonModule, APP_BASE_HREF} from '@angular/common';
import {ResponseHandlerInterceptor} from './shared/httpInterceptor/http-error-handler.service';

import {SharedModule} from './shared/shared.module';
import {EventBusService} from './shared/service/event-bus.service';
import {GlobalCacheService} from './shared/service/global-cache.service';
// import {UniversalInterceptor} from './shared/httpInterceptor/universal.interceptor';

// 使用TranslateHttpLoader加载项目的本地语言json配置文件
export function createTranslateLoader(http: HttpClient) {
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  // 使用绝对路径确保 SSR 和浏览器端都能正确加载（./ 相对路径在 SSR server 端无法解析）
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
  // return new TranslateHttpLoader(http);
}

const IMPORTS = [
  // BrowserModule,
  AppRoutingModule,
  HttpClientModule,
  SharedModule,
  CommonModule,
  BrowserAnimationsModule,
];

@NgModule({
  declarations: [AppComponent],
  imports: [
    ...IMPORTS,
    BrowserModule.withServerTransition({appId: 'serverApp'}),
    TransferHttpCacheModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseHandlerInterceptor,
      multi: true,
    },
    EventBusService,
    GlobalCacheService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
